import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CsfModel } from './csf-model';
import { FacturaService } from 'app/modules/factura/lista-facturas/factura.service';

@Injectable({
    providedIn: 'root'
})
export class DialogNuevoClienteService {
    headers: HttpHeaders;
    url: string;

    constructor(private http: HttpClient,
        private facturaService: FacturaService) {
        //this.headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
        //this.headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        this.headers = new HttpHeaders();
        this.url = environment.serviceUrl;
    }

    postService(formData?: any): Promise<{ status: string, cif: CsfModel, message: string }> {
        return new Promise((resolve, reject) => {
            //this.headers = new HttpHeaders({ skip: "skip" });
            this.http.post(this.url + "csf-read", formData, { headers: this.headers })
            .subscribe({
                next: (response: { status: string, cif: CsfModel, message: string }) => resolve(response),
                error: error => reject(error)
            });
        });
    }

    getClienteById(idCliente: number) {
        return new Promise((resolve, reject) => {
            var url = this.url + `cli-clientes?populate=dir_direccion.dir_asentamiento.dir_codigo_postal,cat_uso_factura,cat_regimen_fiscal,dir_direccion.dir_pai,dir_direccion.dir_estado,dir_direccion.dir_asentaiento,dir_direccion.dir_municipio&filters[id][$eq]=${idCliente}`;
            return this.http.get(url)
            .subscribe({
                next: (res: { error:any, excepcion: any, data: any[] }) => {
                    if (res.error) {
                        reject({ pila: res.error, tipoExcepcion: 4 });
                    } else if (res.excepcion) {
                        reject({ pila: res.excepcion, tipoExcepcion: 3 });
                    } else {
                        resolve(res.data);
                    }
                },
                error: error => reject({ pila: error, tipoExcepcion: 4 })
            });
        });
    }

    getClienteByRfc(idEmpresa: number, rfc: string): Promise<any[]> {
        return new Promise((resolve, reject) => {
            //var url = this.url + `cli-clientes?populate=dir_direccion.dir_asentamiento.dir_codigo_postal,cat_uso_factura,cat_regimen_fiscal,dir_direccion.dir_pai,dir_direccion.dir_estado,dir_direccion.dir_asentaiento,dir_direccion.dir_municipio&filters[rfc][$eq]=${rfc}`;
            var object = this.facturaService.getEmpresaClientesQuery({ rfc: { $contains: `${rfc}` } });
            const query = `ope-empresas/${idEmpresa}?` +
            //`populate[cli_clientes][filters][rfc][$contains]=${rfc}&` +
            this.facturaService.getQueryFromObject(object); // + '&publicationState=live';
            var url = this.url + query;
            return this.http.get(url)
            .subscribe({
                next: (res: { error:any, excepcion: any, data: any }) => {
                    if (res.error) {
                        reject({ pila: res.error, tipoExcepcion: 4 });
                    } else if (res.excepcion) {
                        reject({ pila: res.excepcion, tipoExcepcion: 3 });
                    } else {
                        const clientes = res.data.attributes.cli_clientes.data;
                        resolve(clientes.filter(cli => cli.attributes.rfc == rfc)); //&& cli.publishedAt != null
                    }
                },
                error: error => reject({ pila: error, tipoExcepcion: 4 })
            });
        });
    }

    /*getClienteByRfc(idEmpresa: number, rfc: string): Promise<any[]> {
        return new Promise((resolve, reject) => {
            //var object = this.facturaService.getClienteQuery();
            var url = this.url + `cli-clientes?filters[rfc][$eq]=${rfc}` +
            `&filters[ope_empresa][$eq]=${idEmpresa}` +
            "&populate=dir_direccion.dir_asentamiento.dir_codigo_postal,cat_uso_factura,cat_regimen_fiscal,dir_direccion.dir_pai,dir_direccion.dir_estado,dir_direccion.dir_asentaiento,dir_direccion.dir_municipio";
            return this.http.get(url)
            .subscribe({
                next: (res: { error:any, excepcion: any, data: any[] }) => {
                    if (res.error) {
                        reject({ pila: res.error, tipoExcepcion: 4 });
                    } else if (res.excepcion) {
                        reject({ pila: res.excepcion, tipoExcepcion: 3 });
                    } else {
                        resolve(res.data.filter(cli => {cli.attributes.rfc == rfc}));
                    }
                },
                error: error => reject({ pila: error, tipoExcepcion: 4 })
            });
        });
    }*/
}
